import { addDoc, collection, doc, serverTimestamp, updateDoc } from 'firebase/firestore/lite';
import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { db } from '../../firebase.config';



function Success() {
  const location = useLocation()
  useEffect(()=>{
    const { payload, userCart } = location.state;
    console.log(payload, userCart);
    const userDocId = payload.docId;
    //Function For Adding Order to Subcollection
      const addCartToOrders = async (userDocId, userCart) => {
        console.log('docRef:', userDocId);
        const userDocRef = doc(db, "users", userDocId);

        // Reference the subcollection
        const subcollectionRef = collection(userDocRef, "orders");

        // Add NewOrder to the subcollection

        const newOrder = {
          address: payload.addrs,
          date: new Date(),
          docid: userDocId,
          server: serverTimestamp(),
          total: payload.total,
          payment: true,
          items: userCart,
        };

      // Add a new document to the subcollection
      const docRef = await addDoc(subcollectionRef, newOrder);

      console.log("ref:", userDocId);
      console.log(`Document written with ID: ${docRef.id}`);
      console.log(`Document written with ID: ${docRef}`);
      
      if(docRef){
        const cartReset = await updateDoc(userDocRef, {cart:[]})
        console.log('cartState: ', cartReset)
      }else{
        console.log('Error on placing order!')
      }
    };

          

          addCartToOrders(userDocId,userCart) 
          // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  return (
    <div className="flex flex-col gap-3 text-center items-center justify-center py-auto mb-5 h-screen">
      <img
        src="https://media0.giphy.com/media/NikzzPlFuvoCzWS7IX/giphy.gif?cid=6c09b952kn8y2t2sat31q4easw28efhacxsamzk1ls9xdhzi&rid=giphy.gif&ct=s"
        className="w-28"
        alt="PaymentFailed"
      />
      <p className="flex text-lg font-bodyFont font-bold text-emerald-600">
        Order Placed SuccessFully : )
      </p>
      <Link to={"/orders"}>
        <p className="flex text-md font-bodyFont font-bold text-slate-600">
          Go to your Orders
        </p>
      </Link>
    </div>
  );
}

export default Success
